// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1p-q";
export var animationRelative = "_1p-p";
export var backdropBlur = "_1p-0";
export var detailLabelCell = "_1p-12";
export var detailTable = "_1p-11";
export var detailValueCell = "_1p-13";
export var docIconBox = "_1p-1d";
export var docIconBoxMd = "_1p-1f";
export var docIconBoxSm = "_1p-1e";
export var docTypeRow = "_1p-16";
export var docTypeRowInner = "_1p-17";
export var dropdownMatchDatePicker = "_1p-3";
export var evidenceCardContent = "_1p-1c";
export var fileUploadSpin = "_1p-j";
export var gorgiasOpenButton = "_1p-15 _1p-d";
export var gorgiasTicketCard = "_1p-14";
export var heroModalFooterButton = "_1p-18";
export var hiddenContainer = "_1p-o";
export var iconPrimary = "_1p-1g";
export var iconSecondary = "_1p-1h";
export var iconTertiary = "_1p-1i";
export var integrationCard = "_1p-1";
export var integrationLogoBox = "_1p-2";
export var mainColumnSticky = "_1p-1b";
export var maxWidthContainer = "_1p-19";
export var modalContentBody = "_1p-a";
export var modalHeaderImage = "_1p-5";
export var modalImageLabel = "_1p-7";
export var modalImageOverlay = "_1p-6";
export var modalImageSubtitle = "_1p-9";
export var modalImageTitle = "_1p-8";
export var modalImageWrapper = "_1p-4";
export var modalStickyFooter = "_1p-b";
export var removeButton = "_1p-e";
export var sidebarColumn = "_1p-1a";
export var spinner = "_1p-i";
export var timelineLine = "_1p-y";
export var timelineLineBlack = "_1p-10 _1p-y";
export var timelineLineGray = "_1p-z _1p-y";
export var timelineLineHeight = "_1p-x";
export var tlDotActivate = "_1p-u";
export var tlDotActivateAnim = "_1p-t";
export var tlDotHide = "_1p-s";
export var tlDotHideAnim = "_1p-r";
export var tlLineActivate = "_1p-w";
export var tlLineActivateAnim = "_1p-v";
export var uploadHint = "_1p-n";
export var uploadIconBox = "_1p-k";
export var uploadLabel = "_1p-m";
export var uploadText = "_1p-l";
export var uploadZone = "_1p-f";
export var uploadZoneCursorDefault = "_1p-h";
export var uploadZoneCursorPointer = "_1p-g";
export var uploadedFileRow = "_1p-c";
export var viewButton = "_1p-d";